import { css } from '@emotion/core'
import theme from 'Theme'

const {
  colors,
  mixins,
  typography,
  spacing,
  components: { productCard }
} = theme

const priceStyles = dataItemsPerRow => {
  if (dataItemsPerRow === 4) {
    return `
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .original-price {
        margin-left: 0;
      }
    `
  }

  return ``
}

export const plain = props => {
  const { dataItemsPerRow } = props
  return css`
    min-height: 200px;
    padding: 1rem 0;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${colors.white};
    border: 1px solid ${colors.borderGrey};

    .show-spinner > .spinner > .loader {
      width: 50px;
      height: 50px;
      font-size: 7px;
    }

    .image-link {
      transition: border-color 150ms ease-in;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 130%;
      position: relative;
    }

    .img-wrapper {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: ${spacing.base_1}px;
    }

    img {
      max-height: 100%;
      flex-shrink: 0;
      object-fit: contain;
    }

    .footer {
      display: block;
      padding: 0 ${spacing.base_1}px ${spacing.base_1}px;
      > * {
        margin-bottom: 4px;
      }
      h5 {
        font-weight: normal;
        font-size: 15px;
        margin-bottom: ${spacing.base_2}px;
      }
      .brand {
        margin-bottom: ${spacing.base_1}px;
      }
    }

    .brand {
      ${mixins.subText(theme)}
      font-size: ${typography.sizes.small}
    }

    .price {
      font-size: 15px;
      font-weight: bold;
      line-height: 1;
      ${priceStyles(dataItemsPerRow)}
    }

    &:hover {
      ${mixins.cardBoxShadow(theme)};
    }

    .card-details {
      display: block;
      padding: 16px 8px 8px 8px;

      h4 {
        margin-bottom: 8px;
      }

      &:visited {
        h4 {
          color: ${colors.body};
        }
      }

      &:active {
        h4 {
          color: ${colors.body};
        }
      }
    }

    h4 {
      color: ${colors.body};
      line-height: ${productCard.titleLineHeight};
      font-weight: normal;
    }

    .discount {
      text-decoration: line-through;
      color: ${productCard.discountColor};
    }

    .favourite-button {
      position: absolute;
      bottom: 0;
      right: 0;
      svg[name='favorite_border'] {
        fill: ${colors.borderGrey};
      }
    }
  `
}

export default plain
